import { schema } from 'normalizr';

export interface Document {
  id: string;
  description: string;
  name?: string;
  url: string;
  attachment_type?: 'study_guide' | 'slide';
}

export const documentSchema = new schema.Entity('documents');

export interface LinkAttachment {
  id: string;
  name: string;
  url: string;
  attachment_type?: 'study_guide' | 'slide';
}

export const linkAttachmentSchema = new schema.Entity('link_attachments');
